import { render } from "./TheCartAddedProductCard.vue?vue&type=template&id=88c58926"
import script from "./TheCartAddedProductCard.vue?vue&type=script&lang=js"
export * from "./TheCartAddedProductCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__